import classNames from 'classnames';
import { inject } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import RouterPropTypes from 'react-router-prop-types';

import Analytics from '../../../analytics/Analytics';
import { modelOf } from '../../../prop-types';
import ConfigStore from '../../../store/ConfigStore';
import TrackingStore from '../../../store/TrackingStore';
import UIStore from '../../../store/UIStore';

class Page extends Component {
  constructor(props) {
    super(props);

    this.yotpoTimeout = null;
  }

  componentDidMount() {
    const { analytics, configStore, uiStore, name } = this.props;
    uiStore.setCurrentPage(name);
    analytics.setPage(name);
    !window.isSSR && this.sendTrackingData();

    if (configStore.integrations.yotpo.enabled && window && window.yotpo) {
      this.yotpoTimeout = setTimeout(() => {
        window.yotpo.refreshWidgets();
      }, 800);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      !window.isSSR &&
      prevProps.location.pathname !== this.props.location.pathname
    ) {
      this.sendTrackingData();
    }
  }

  componentWillUnmount() {
    this.yotpoTimeout && clearTimeout(this.yotpoTimeout);
  }

  sendTrackingData = () => {
    const { trackingStore, onDefinedTrackingPage, configStore } = this.props;

    if (
      !configStore.integrations.spotmore.enabled ||
      typeof document === 'undefined' ||
      onDefinedTrackingPage
    ) {
      return null;
    }

    if (configStore.integrations.spotmore.enabled && window.crmtracker) {
      window.crmtracker.sendData();
    }

    trackingStore.setPageView({
      visitedUrl: window.location.href,
      refererUrl: document.referrer,
    });
    trackingStore.postPageView();
  };

  render() {
    const { className, children } = this.props;

    return <main className={classNames('Page', className)}>{children}</main>;
  }
}

Page.propTypes = {
  configStore: modelOf(ConfigStore).isRequired,
  trackingStore: modelOf(TrackingStore).isRequired,
  uiStore: modelOf(UIStore).isRequired,
  analytics: PropTypes.instanceOf(Analytics).isRequired,
  location: RouterPropTypes.location.isRequired,
  name: PropTypes.string.isRequired,
  onDefinedTrackingPage: PropTypes.string,
};

export default inject(
  'analytics',
  'uiStore',
  'trackingStore',
  'configStore'
)(withRouter(Page));
